// extracted by mini-css-extract-plugin
export default {"toolbarIcon":"index_toolbarIcon__-rhS+","toolbarIconButton":"index_toolbarIconButton__eFb5b"};